import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import { changelang } from "../../components/funtionsBD/Mainservice";
import { APP_LANGUAGES, applyAppLanguage, currentAppLanguage } from "../../utils/appLanguages";
import "./ChangeLng.css";

const CheckIcon = () => (
  <svg
    className="change-lng__check"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M20 6L9 17l-5-5"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChangeLng = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [selectedlng, setselectedlng] = useState(() => currentAppLanguage(i18n));
  const [pending, setPending] = useState(null);

  const changeLanguage = async (lng) => {
    if (pending) return;
    if (lng === selectedlng) {
      navigate("/profile");
      return;
    }
    setPending(lng);
    setselectedlng(lng);
    applyAppLanguage(i18n, lng);
    try {
      if (typeof i18n?.changeLanguage === "function") {
        await i18n.changeLanguage(lng);
      }
    } catch {
      /* local storage already updated */
    }
    try {
      await changelang(lng);
    } catch (error) {
      console.warn(
        "changeLang API failed; UI language still applied:",
        error?.message || error
      );
    } finally {
      setPending(null);
      navigate("/profile");
    }
  };

  return (
    <div id="adminRoot" className="change-lng-page">
      <AddHeader title={t("changelanguage")} />
      <main className="change-lng">
        <p className="change-lng__hint">{t("select_language_hint")}</p>
        <ul className="change-lng__list" role="listbox" aria-label={t("changelanguage")}>
          {APP_LANGUAGES.map((lang, index) => {
            const isSelected = selectedlng === lang.code;
            const isPending = pending === lang.code;
            return (
              <li key={lang.code} className="change-lng__item-wrap">
                {index > 0 ? <div className="change-lng__divider" aria-hidden="true" /> : null}
                <button
                  type="button"
                  role="option"
                  aria-selected={isSelected}
                  className={`change-lng__item${isSelected ? " is-selected" : ""}${
                    isPending ? " is-pending" : ""
                  }`}
                  onClick={() => changeLanguage(lang.code)}
                >
                  <span className="change-lng__flag" aria-hidden="true">
                    {lang.flag}
                  </span>
                  <span className="change-lng__meta">
                    <span className="change-lng__name">{lang.nativeName}</span>
                    <span className="change-lng__code">{lang.code.toUpperCase()}</span>
                  </span>
                  {isSelected ? <CheckIcon /> : <span className="change-lng__spacer" />}
                </button>
              </li>
            );
          })}
        </ul>
      </main>
    </div>
  );
};
